import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const getTransactionReport = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "admin/reports/transactions",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
      cacheTTL: 300000,
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    return await request(config);
  } catch (err: any) {
    throw new Error(err);
  }
};

const getItemReport = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "admin/reports/items",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
      cacheTTL: 300000,
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    return await request(config);
  } catch (err: any) {
    throw new Error(err);
  }
};

const getStoreReport = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "admin/reports/stores",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
      cacheTTL: 300000,
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    return await request(config);
  } catch (err: any) {
    throw new Error(err);
  }
};

const getDisbursementReport = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "admin/reports/disbursements",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
      cacheTTL: 300000,
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    return await request(config);
  } catch (err: any) {
    throw new Error(err);
  }
};

const getDeliveryReport = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "admin/reports/deliveries",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
      cacheTTL: 300000,
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    return await request(config);
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  getTransactionReport,
  getItemReport,
  getStoreReport,
  getDisbursementReport,
  getDeliveryReport,
};
